import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Robustand = () => {
  return (
    <div className="Robustand p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <h2>Our Front-line Startup Prototype Services</h2>
                        <p>Revolutionize your ambitions into tangible success with our pioneering Startup Prototype Services. We focus on creating innovative prototypes, guiding your vision to completion. Partner with TekRevol to enhance your startup's potential, confirming a dynamic and market-ready prototype that sets you apart in the competitive world.</p>
                        <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Let’s Build Your Custom Software</Link>
                    </Col>
                    <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
                        <div className="robustscroll">
                        <div className="robust-box">
                            <div className="robust-content">
                                <h4>Ideation Excellence</h4>
                                <p>Ideation Excellence: Change visionary ideas into robust prototypes with our Ideation Excellence service. Our team outshines in translating your concepts into perceptible models, laying a solid groundwork for your startup's odyssey towards success.</p>
                            </div>
                            <div className="robust-content">
                                <h4>Agile Design Iterations</h4>
                                <p>Agile Design Iterations: Stay in front of the competition with our Agile Design Iterations service. We contemplate the dynamic nature of markets and user expectations, providing swift and adaptive design changes.</p>
                            </div>
                            <div className="robust-content">
                                <h4>Precision Prototyping</h4>
                                <p>Precision Prototyping: Grow your startup with our Precision Prototyping service. Our procedures include a rigorous method to craftsmanship and technical brilliance, guaranteeing your prototype not only meets but surpasses industry standards, setting the stage for success.</p>
                            </div>
                            <div className="robust-content">
                                <h4>Market Validation Solutions</h4>
                                <p>Market Validation Solutions: Validate your market existence with our complete Market Validation Solutions. We utilize rigorous testing and validation strategies to guarantee your prototype aligns flawlessly with market requirements and user expectations.</p>
                            </div>
                            <div className="robust-content">
                                <h4>Investor-Ready Presentation</h4>
                                <p>Investor-Ready Presentation: Secure investor confidence with our Investor-Ready Presentation service. We comprehend the importance of a persuasive display when seeking financial support. Our team formulates your prototype for investor pitches, guaranteeing a resounding and professional presentation of your startup's potential.</p>
                            </div>
                        </div>
                        </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Robustand